import moment from 'moment'

export default {
    params: ['date'],
    validate: (value, { date }) => moment(value, 'DD/MM/YYYY') >= moment(date),
    message: (field, { date }) => `${field} deve ser maior ou igual à ${moment(date).format('DD/MM/YYYY')}.`,
}